import React, { useEffect, useMemo, useState } from 'react'
import ResizeObserver from 'rc-resize-observer'
import styles from './index.less'
import { isNumber } from '@/utils/utils'
import SceneFilteringBoxWrapper from '@/modules/globals/components/SceneFilteringBoxWrapper'
import getQuickSearchApplyValues from '../../helper/getQuickSearchApplyValues'
import SelectCheckbox from '@/modules/order/components/SelectCheckbox'

// 获取查询应用数据，应用数据需要全字段
export const getQuickSearchPreOptionsSolts = ({ sceneFilterSolts, selectName, count }) => {
    if(sceneFilterSolts) {
        return sceneFilterSolts
    }

    return  [{
        content: (<span>{selectName}</span>),
        count: isNumber(count) ? count : null
    }]
}

const SceneSelectFilteringBoxWrapper = ({
    dataSource,
    quickSearchSelected,
    quickSearchPreOptions,
    quickSearchPreOptionsRender,
    checkIsActive,
    onSetClick
}:any) => {
    const {dataLogText, svgPic, noNum, noValue, menuOptions} = dataSource || {}
    const [curNoNum, setCurNoNum] = useState(noNum)
    const [curNoValue, setCurNoValue] = useState(noValue)

    useEffect(() => {
        if(isNumber(curNoValue?.noNum)) {
            setCurNoNum(curNoValue?.noNum)
        } else {
            setCurNoNum(dataSource?.noNum)
        }
    }, [curNoValue?.noNum, dataSource])

    const targetNoValue = useMemo(() => {
        return {
            ...(curNoValue || {}),
            checked: quickSearchSelected === curNoValue?.value
        }
    }, [curNoValue, quickSearchSelected])


    return <div data-log-text={dataLogText} className={styles.preItem}>
                <SelectCheckbox
                    checkStyle={{ height: '28px' }}
                    svgPic={svgPic}
                    noValue={targetNoValue}
                    noNum={curNoNum}
                    menuOptions={menuOptions}
                    onSet={(val, eventType)=>{
                        setCurNoValue(val)
                        const target = quickSearchPreOptions.find(item => item.key === val?.value)
                        if(target) {
                            let isActive = false
                            if(eventType === 'menuLeft') {
                                isActive = checkIsActive?.(target)
                            }
                            onSetClick?.(target, isActive)
                        }
                    }}
                    leftBoxStyle={{ padding: '0 4px' }}
                />
            </div>
}

export default ({
    quickSearchPreOptions,
    quickSearchPreSelectDisplay,
    quickSearchSelected,
    quickSearchPreOptionsRender,
    fieldsGroup,
    sortFields,
    children,
    onSelectQuickSearch,
}:any) => {
    const [containerWidth, setContainerWidth] = useState(0)

    const quickSearchPreDisplayList = quickSearchPreSelectDisplay || quickSearchPreOptions

    const checkIsActive = target => {
        return target.key === quickSearchSelected
    }

    const handleContainerResize = ({ width }) => {
        setContainerWidth(width)
    }

    const toggleApplyItem = (item, isActive) => {
        if (isActive) {
            onSelectQuickSearch(getQuickSearchApplyValues({ quickItem: null, fieldsGroup, sortFields }))
        } else {
            onSelectQuickSearch(getQuickSearchApplyValues({ quickItem: item, fieldsGroup, sortFields }))
        }
    }


    const nodes = typeof quickSearchPreOptionsRender === 'function' ? quickSearchPreOptionsRender({ quickSearchPreOptions, quickSearchPreDisplayList, quickSearchSelected, checkIsActive, toggleApplyItem }) : quickSearchPreDisplayList.map(item => {
        const isActive = checkIsActive(item)
        const solts = getQuickSearchPreOptionsSolts(item)

        if(Array.isArray(item?.menuOptions)) {
            return (
                <SceneSelectFilteringBoxWrapper
                    dataSource={item}
                    quickSearchSelected={quickSearchSelected}
                    quickSearchPreOptions={quickSearchPreOptions}
                    checkIsActive={checkIsActive}
                    onSetClick={(target, isTargetActive) => {
                        toggleApplyItem(target, isTargetActive)
                    }}
                />
            )
        }

        return (
            <SceneFilteringBoxWrapper
                key={item.key}
                className={styles.preItem}
                data-log-text={item.selectName}
                data-log-checked={!isActive}
                solts={solts}
                isSelected={isActive}
                onClick={() => {
                    toggleApplyItem(item, isActive)
                }}
            />

        )
    })

    return (
        <ResizeObserver onResize={handleContainerResize}>
            <div className={styles.container}>
                {nodes}
                {children}
            </div>
        </ResizeObserver>
    )
}
